import * as THREE from 'three';
import vOutlineShader from '../shaders/outline_vert.glsl'
import fOutlineShader from '../shaders/outline_frag.glsl'

export class OutlineMaterial extends THREE.ShaderMaterial {
  constructor(parameters) {

    parameters = parameters || {};

    var defines = {};

    var uniforms = THREE.UniformsUtils.merge(  [
      {
          color: { value: new THREE.Color(0x000000) },
          size: {type:"f", value:.02},
          time: {type:"f", value: 0},
      }
    ] );

    var vertexShader = vOutlineShader;

    var fragmentShader = fOutlineShader;

    super({
      vertexShader:vertexShader,
      fragmentShader:fragmentShader,
      uniforms:uniforms,
      defines:defines,
      side:THREE.BackSide,
    });

    this.setValues( parameters );

  }

  set color(v) {
    this.uniforms.color.value = v;
  }

  get color() {
    return this.uniforms.color.value;
  }   

  set size(v) {
    this.uniforms.size.value = v;
  }

  get size() {
    return this.uniforms.size.value;
  }   

  set time(v) {
    this.uniforms.time.value = v;
  }

  get time() {
    return this.uniforms.time.value;
  }   

}